import useSWRMutation from "swr/mutation";
import { sendRequest } from "../../helpers/fetchHandleError";
import { useNotify } from "react-admin";
import { fetchWithFBToken } from "../Common/swrMiddlewares";
import { useProfile } from "./useProfile";
import { useFBToken } from "./fbPageProfile";

export const useSendFbMessage = (
  url = `${process.env.REACT_APP_GRAPH_API_URL}/me/messages`,
  fetcher = sendRequest,
  option = {}
) => {
  const { profile } = useProfile();
  const theUrl = new URL(url);
  theUrl.searchParams.set("access_token", profile ? profile.page.token : "");

  const notify = useNotify();
  return useSWRMutation(theUrl, fetcher, {
    // use: [fetchWithFBToken],
    onError: (e) => {
      notify(e.error.message, { type: "error" });
    },
    ...option,
  });
};
